import { render, staticRenderFns } from "./PlatformtemplatePricePercentage.vue?vue&type=template&id=7db370e0&"
import script from "./PlatformtemplatePricePercentage.vue?vue&type=script&lang=js&"
export * from "./PlatformtemplatePricePercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports